import React from 'react';
import { Box, Paper, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as Logo } from "../../img/logo.svg"
import { useColors } from '../../Theme/ColorModeContext';

const SignInPage = () => {
  const { loginWithRedirect } = useAuth0();
  const colors = useColors();

  const handleSignIn = () => {
    loginWithRedirect();
  };

  return (
    <Box
      sx={{
        backgroundColor: colors.background.paper,
        m: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { sm: '40px', xs: '20px 16px', lg: '45px', xl: '45px' },
        boxSizing: 'border-box',
      }}
    >
      <Paper
        sx={{
          backgroundColor: colors.background.paper,
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          boxSizing: 'border-box',
          overflowY: 'auto',
          padding: { sm: '30px', xs: '20px 16px' },
          borderRadius: '10px',
          boxShadow: `0px 1px 13.6px 0px ${colors.border.mild}`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box
            sx={{
              margin: '0 auto',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              width: { xs: '100%', md: '50%' },
              alignItems: 'center',
              justifyContent: 'space-between',
              maxWidth: '100%',
              minWidth: { xs: 'auto', sm: '300px', md: '433px' },
              py: 4,
            }}
          >
            <Logo
              style={{
                minWidth: '199px',
                maxWidth: '600px',
                width: '100%',
                minHeight: '55px',
                height:"auto", 
                maxHeight:"100px"
              }}
            />

            <Button
              sx={{
                width: { xs: '100%', sm: '80%' },
                 maxWidth: '600px',
                height: '47.44px',
                borderRadius: '7.93px',
                color: colors.primary.contrastText,
                padding: '13.72px 18px',
                backgroundColor: colors.primary.main,
                '&:hover': {
                  backgroundColor: colors.primary.main,
                },
              }}
              onClick={handleSignIn}
            >
              Sign In
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default SignInPage;